import { useRouter } from 'next/router'
import { Fragment } from 'react'
import { useTheme } from 'styled-components'

import { HideAtOrLarger } from '@/components/shared/breakpoint'
import { ErrorBoundary } from '@/components/shared/error-boundary'
import { LinkCustom } from '@/components/shared/link-custom/LinkCustom'
import { isDominantCategorySearch } from '@/domain/srp/isDominantCategorySearch'
import { seoUrlToString } from '@/domain/urls'
import { useGetRelatedUrlGroupsQuery } from '@/generated'
import { useGetSearchResultsData } from '@/hooks/srp/useGetSearchResultsData'
import { Accordion, AccordionItem } from '@/ui/atoms/accordion'
import { Divider } from '@/ui/atoms/divider'
import { Spacing } from '@/ui/atoms/spacing'

import { SeoLinksGroup } from './styled'

export const SeoLinks = () => {
  const { data: { searchQuery } = {}, loading } = useGetSearchResultsData()
  const { spacing } = useTheme()
  const { asPath } = useRouter()

  const categoryId = searchQuery?.category?.id
  const locationId = searchQuery?.location?.id

  const isDomCat = isDominantCategorySearch(asPath)

  const searchUrlsRelatedGroupsInput = {
    categoryId: `${categoryId}`,
    location: { id: locationId },
  }

  /**
   * Possible improvement:
   * We could use the url decoder to get the category & location from the URL and start this call if we know it is not a domCat search
   * */
  const { data } = useGetRelatedUrlGroupsQuery({
    variables: { searchUrlsRelatedGroupsInput },
    skip: (loading && isDomCat) || typeof categoryId === 'undefined',
  })

  const seoBottomLinks = data?.searchUrlsRelatedGroups || []

  if (!seoBottomLinks.length) return null

  return (
    <ErrorBoundary fingerprintId="SeoLinks">
      <Spacing mTop={spacing.large} data-testid="seo-bottom-links-container">
        <Accordion gap={0}>
          {seoBottomLinks.map((item, groupIndex) => (
            <Fragment key={`seo-link-group-${groupIndex}`}>
              <Divider bottom=".1rem" top=".1rem" />

              <AccordionItem id={`seo-link-group-${groupIndex}`} title={item.label}>
                <SeoLinksGroup data-testid="seo-link-item">
                  {item.relatedUrls.map((link, linkIndex) => (
                    <li key={`seo-link-item-group:${groupIndex}-${linkIndex}`}>
                      <LinkCustom variant="secondary" href={seoUrlToString(link.url)} hasUnderline>
                        {link.label}
                      </LinkCustom>
                    </li>
                  ))}
                </SeoLinksGroup>
              </AccordionItem>
            </Fragment>
          ))}
        </Accordion>

        <HideAtOrLarger breakpoint="medium">
          <Divider top=".1rem" />
        </HideAtOrLarger>
      </Spacing>
    </ErrorBoundary>
  )
}
